export const EvaluationTrainingHotCriterion = {
    path: '/evaluation_training_hot_criterion',
    name: 'evaluation_training_hot_criterion',
    component: () => import('@/views/Evaluation/Measure/EvaluationTrainingHotMeasurePage.vue'),
    props: {
        type: 'EVALUATION_TRAINING_HOT',
    },
    children: [
        {
            path: '/evaluation_training_hot_criterion/add',
            name: 'evaluation_training_hot_criterion.add',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_criterion/edit/:id',
            name: 'evaluation_training_hot_criterion.edit',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_criterion/delete/:id',
            name: 'evaluation_training_hot_criterion.delete',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
        {
            path: '/evaluation_training_hot_criterion/view/:id',
            name: 'evaluation_training_hot_criterion.view',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_TRAINING_HOT',
            }
        },
    ]
}